import Vue from 'vue'
import AuthService from './auth.service'
export default {
    /**
     * 记录日志信息
     *
     * @param {*} [params={}]
     * @param {*} [config={}]
     * @returns
     */
    async WriteLog(params = {}, config = {}) {
        AuthService.getToken();
        let result = await Vue.http.post('/CommonTool/WriteLog', params, config);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/_services/common.service.js